import React from "react";
import { STATUS, labelStatus } from "@/lib/constants";
import { TASK_PRIORITY, fmtDate } from "@/lib/tasks";

export const PriorityBadge = ({ p, testid }) => {
  const s = TASK_PRIORITY[p] || TASK_PRIORITY.normal;
  return <span data-testid={testid} className={`inline-flex items-center px-1.5 py-0.5 rounded border text-[10px] font-semibold uppercase tracking-wide ${s.cls}`}>{s.label}</span>;
};

export const StatusBadge = ({ t, testid }) => {
  if (t.type === "inspection") {
    const label = t.is_closed ? "Durchgeführt" : t.is_overdue ? "Überfällig" : "Fällig";
    const cls = t.is_closed ? "bg-green-50 text-green-700 border-green-200" : t.is_overdue ? "bg-red-50 text-red-700 border-red-200" : "bg-sky-50 text-sky-700 border-sky-200";
    return <span data-testid={testid} className={`inline-flex px-1.5 py-0.5 rounded border text-[11px] font-medium ${cls}`}>{label}</span>;
  }
  const s = STATUS[t.status] || STATUS.offen;
  return <span data-testid={testid} className={`inline-flex px-1.5 py-0.5 rounded border text-[11px] font-medium ${s.bg} ${s.text} ${s.border}`}>{labelStatus(t.status)}</span>;
};

export const DueLabel = ({ t, today, testid }) => {
  if (!t.due_date) return <span data-testid={testid} className="text-slate-400 text-xs">ohne Frist</span>;
  const cls = t.is_overdue ? "text-red-600 font-semibold" : t.due_date === today && !t.is_closed ? "text-amber-600 font-semibold" : "text-slate-600";
  return <span data-testid={testid} className={`text-xs font-mono-tech ${cls}`}>{t.due_date === today && !t.is_closed ? "Heute" : fmtDate(t.due_date)}{t.is_overdue ? " · überfällig" : ""}</span>;
};
